// extracted by mini-css-extract-plugin
module.exports = {"leftPanel":"emailVerifyStyles__leftPanel--GfISX","rightPanel":"emailVerifyStyles__rightPanel--2EwIV"};